import React from 'react';
import './AccountabilityList.css';

const AccountabilityList = () => {
    const items = [
        {
            id: 1,
            name: "Angela Bernier",
            description: "Send a package request Include the item's & Provide any special instructions.",
            time: "53 min ago",
            icon: "🕒"
        },
        {
            id: 2,
            title: "Great! Total revenue just about to fly",
            description: "Revenue is starting to rise up for clients with overall clients and tasks.",
            time: "Just 30 sec ago",
            icon: "⏰"
        },
        {
            id: 3,
            title: "Client Milestone Acknowledgment",
            description: "Acknowledge and celebrate client milestones achieved this week.",
            time: "Just 30 sec ago",
            icon: "✅"
        }
    ];

    return (
        <div className="accountability-list">
            <h2>Accountability list</h2>
            {items.map(item => (
                <div key={item.id} className="accountability-item">
                    <div className="item-icon">{item.icon}</div>
                    <div className="item-content">
                        {item.name && <h3>{item.name}</h3>}
                        {item.title && <h3>{item.title}</h3>}
                        <p>{item.description}</p>
                        <span className="item-time">{item.time}</span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AccountabilityList;
